import React from 'react';
import { ImFacebook, ImInstagram, ImLinkedin } from 'react-icons/im';

const Socials = () => {
  // Replace the 'your-links-here' with your actual social media profile links
  const socialLinks = {
    facebook: 'your-facebook-link',
    instagram: 'https://www.instagram.com/dream_assignment?igshid=OGQ5ZDc2ODk2ZA==',
    linkedin: 'your-linkedin-link',
  };

  return (
    <div className='hidden xl:flex ml-24 items-center'>
      {/* Facebook */}
      <a href={socialLinks.facebook} target='_blank' rel='noopener noreferrer' className='mr-2'>
        <ImFacebook size={24} color='#3b5998' />
      </a>
      {/* Instagram */}
      <a href={socialLinks.instagram} target='_blank' rel='noopener noreferrer' className='mr-2'>
        <ImInstagram size={24} color='#e4405f' />
      </a>
      {/* LinkedIn */}
      <a href={socialLinks.linkedin} target='_blank' rel='noopener noreferrer'>
        <ImLinkedin size={24} color='#0077b5' />
      </a>
    </div>
  );
};

export default Socials;

